import React, { useEffect } from 'react';
import { StyleSheet, ScrollView, View, Text, Image } from 'react-native';
import { useMediaQuery } from 'react-responsive';

import Button from 'shared/modules/common/components/atoms/Button';
import NumberOneImg from 'shared/modules/ekyc/assets/images/1@3x.png';
import NumberTwoImg from 'shared/modules/ekyc/assets/images/2@3x.png';
import NumberThreeImg from 'shared/modules/ekyc/assets/images/3@3x.png';
import IdCardImg from 'shared/modules/ekyc/assets/images/id-card@3x.png';
import PhoneScreenImg from 'shared/modules/ekyc/assets/images/phone-screen@3x.png';
import SelfieImg from 'shared/modules/ekyc/assets/images/selfie@3x.png';

const InfoStage = (props: {
  onNextButtonPress: () => void;
  onFocus?: () => void;
  onBlur?: () => void;
}) => {
  const { onNextButtonPress, onFocus, onBlur } = props;
  const isBigScreen = useMediaQuery({ minWidth: 768 });

  useEffect(() => {
    onFocus?.();

    return () => onBlur?.();
  }, []);

  return (
    <View style={styles.root}>
      <ScrollView style={styles.scrollView}>
        <Text style={styles.mainTitle}>{`かんたん３ステップ`} </Text>
        {/* First row */}
        <View style={styles.subView}>
          <View style={styles.numberView}>
            <Image source={{ uri: NumberOneImg }} style={styles.numberImage} />
          </View>
          <View style={styles.textView}>
            <Text style={styles.text}>
              {isBigScreen
                ? `運転免許証または
マイナンバーカードの情報を読み取る。`
                : `運転免許証または\nマイナンバー\nカードの情報を\n読み取る。`}
            </Text>
          </View>
          <View style={styles.imageView}>
            <Image source={{ uri: IdCardImg }} style={styles.infoImage} />
          </View>
        </View>

        {/* Second row */}
        <View style={styles.subView}>
          <View style={styles.numberView}>
            <Image source={{ uri: NumberTwoImg }} style={styles.numberImage} />
          </View>
          <View style={styles.textView}>
            <Text style={styles.text}>{`顔写真を撮影。`}</Text>
          </View>
          <View style={styles.imageView}>
            <Image source={{ uri: SelfieImg }} style={styles.infoImage} />
          </View>
        </View>

        {/* Third row */}
        <View style={styles.subView}>
          <View style={styles.numberView}>
            <Image
              source={{ uri: NumberThreeImg }}
              style={styles.numberImage}
            />
          </View>
          <View style={styles.textView}>
            <Text style={styles.text}>
              {isBigScreen
                ? `必要事項を記入して\n完了。`
                : `必要事項を\n記入して完了。`}
            </Text>
          </View>
          <View style={styles.imageView}>
            <Image source={{ uri: PhoneScreenImg }} style={styles.infoImage} />
          </View>
        </View>
      </ScrollView>
      <View style={styles.buttonContainer}>
        <Button
          variant="primary"
          title="次へ"
          onPress={onNextButtonPress}
          style={styles.nextButton}
          id="ekyc-onboarding-info-stage-next-button"
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
  },
  scrollView: {
    flexGrow: 1,
    marginBottom: 24,
  },
  nextButton: {
    maxWidth: 296,
    alignSelf: 'center',
  },
  mainTitle: {
    fontSize: 20,
    fontWeight: '600',
    marginBottom: 24,
    color: '#000',
  },
  subView: {
    flexDirection: 'row',
    padding: 24,
    backgroundColor: '#fff',
    borderRadius: 16,
    marginBottom: 24,
  },
  numberView: {
    flex: 1.5,
    justifyContent: 'center',
  },
  numberImage: {
    width: 30,
    height: 40,
  },
  textView: {
    flex: 4,
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  text: {
    fontSize: 13,
    fontWeight: '600',
  },
  imageView: {
    flex: 4,
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  infoImage: {
    width: 104,
    height: 80,
  },
  buttonContainer: {
    flex: 1,
    flexDirection: 'row',
    flexGrow: 1,
    alignItems: 'flex-end',
    justifyContent: 'center',
    marginBottom: 18,
  },
});

export default InfoStage;
